const statusTranslate = {
  'open': 'Aberto',
  'finished': 'Finalizado',
  'done': 'Atendido',
  'cancelled': 'Cancelado',
}

export default statusTranslate;